module.exports = __webpack_public_path__ + "02_bob_gray.096da63c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/02_bob_gray.png
// module id = BV3v
// module chunks = 0